import { useEffect, useRef, useState } from 'react';

import type { CUSTOMER_DATA_TAB } from 'cpool-constants';
import type { FieldErrors } from 'react-hook-form';

import { useCustomerDataTabsContext } from '~/features/leadDetails/context/CustomerDataTabsContext.tsx';

export const extractErrorPaths = (obj: object, prefix = ''): Array<string> => {
    return Object.entries(obj).flatMap(([key, value]): string | Array<string> => {
        const fullKey = prefix ? `${prefix}.${key}` : key;
        if (value !== null && typeof value === 'object' && !Array.isArray(value) && !value.message && !value.ref) {
            return extractErrorPaths(value, fullKey);
        }
        return fullKey;
    });
};

export const useTabErrorNotification = (
    tab: CUSTOMER_DATA_TAB,
    errors: FieldErrors,
    prefix = 'NOTIFICATION_HANDLER',
) => {
    const [errorPaths, setErrorPaths] = useState<Array<string>>([]);
    const lastErrorPaths = useRef<Array<string>>([]);
    const { notifications, setNotifications } = useCustomerDataTabsContext();

    // NOTE: we cannot use "errors" in the useEffect dependencies to react to this, because the object reference is always the same
    const currentErrorPaths = extractErrorPaths(errors);
    if (currentErrorPaths.length !== errorPaths.length) setErrorPaths(currentErrorPaths);

    useEffect(() => {
        if (errorPaths === lastErrorPaths.current) return;
        lastErrorPaths.current = errorPaths;

        setNotifications({
            notifications: errorPaths,
            prefix,
            tab,
        });
    }, [setNotifications, tab, notifications, errorPaths, prefix]);
};
